module.exports = __webpack_public_path__ + "static/media/SOIRART.df1d0086.png";